import { render } from "./TvmFlowEndGeneralComponents.vue?vue&type=template&id=07976c48"
import script from "./TvmFlowEndGeneralComponents.vue?vue&type=script&lang=js"
export * from "./TvmFlowEndGeneralComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/TvmFlowEndItems/TvmFlowEndGeneralComponents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07976c48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07976c48', __exports__)) {
    api.reload('07976c48', __exports__)
  }
  
  module.hot.accept("./TvmFlowEndGeneralComponents.vue?vue&type=template&id=07976c48", () => {
    api.rerender('07976c48', render)
  })

}


export default __exports__